import { render, staticRenderFns } from "./ClassroomDetailInformation.vue?vue&type=template&id=6267ed0e&scoped=true"
import script from "./ClassroomDetailInformation.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailInformation.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailInformation.vue?vue&type=style&index=0&id=6267ed0e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6267ed0e",
  null
  
)

export default component.exports